/**
 * 전투 단위의 공통 상수.
 *
 * 병종 수치는 여기 없다. 전부 troops.ts에 있고 병사마다 개별로 들어간다.
 * 이 파일에는 진영과 규모 상한처럼 병종과 무관한 것만 남긴다.
 */

/** 시뮬레이션 주파수. 틱 30이 1초다. */
export const TICK_HZ = 30;

/** 한 전투에 들어갈 수 있는 최대 인원. 양 진영 합계다. */
export const MAX_UNITS = 1400;

/** 동시에 날아다닐 수 있는 화살 수. */
export const MAX_PROJECTILES = 512;

export const Team = {
  Player: 0,
  Enemy: 1,
} as const;
export type Team = (typeof Team)[keyof typeof Team];
